/* ============================================================================
   TACFENDER — GemPages-independence runtime (adapted from the proven Flashen
   fp-gp-runtime v3). Replaces ONLY the glue the paid GemPages app embed used
   to run at hydration. The real gp-* component scripts (accordion, carousel,
   product, sticky, bundle-discount, tab...) stay BAKED in the sections and are
   loaded from assets.gemcommerce.com — never stub-register those tags.
   Also stamps the A/B variant (cookie tf_ab, set in theme.liquid) as a cart
   attribute so every order shows which landing produced it.
   ========================================================================== */
(function () {
  'use strict';

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function each(sel, root, fn) { Array.prototype.forEach.call((root || document).querySelectorAll(sel), fn); }
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function safe(fn) { try { fn(); } catch (e) { /* one broken widget never breaks the rest */ } }

  /* ---- 0) A/B variant helpers -------------------------------------------- */
  function abVariant() {
    /* A/B test concluded 2026-07-30 (B won). This runtime now only serves the home,
       so no order originates from variant A anymore. Returning '' makes
       stampAbAttribute() a no-op — reading the old cookie (90-day lifetime) would
       mis-stamp returning visitors as 'A' long after the test ended. */
    return '';
  }
  function abTrack(event, params) {
    // fire only if the store ever gets GA4/gtag installed; free no-op today
    try {
      if (typeof window.gtag === 'function') {
        var p = params || {}; p.tf_ab = abVariant() || 'off';
        window.gtag('event', event, p);
      }
    } catch (e) {}
  }

  /* ---- 1) CSS the app embed used to inject at hydration ------------------ */
  (function injectRuntimeCss() {
    var css = [
      /* accordion: neutralize the baked gp-transition-all on the collapse chain.
         A perpetually-restarting transition pins the computed heights at their
         old values (transitions outrank even inline !important), which is why
         no amount of inline height could open the FAQ items. Our own height
         transition on the body provides the open/close animation instead. */
      '.gps .gp-accordion-item, .gps .gp-accordion-item_body, .gps .gp-accordion-item_body-inner{transition:none!important;animation:none!important;}',
      '.gps .gp-accordion-item_body{position:static!important;}',
      '.gps .gp-accordion-item{height:auto!important;max-height:none!important;}'
    ].join('\n');
    var tag = document.createElement('style');
    tag.textContent = css;
    (document.head || document.documentElement).appendChild(tag);
  })();

  /* ---- 2) Reveal lazy content the app embed used to handle --------------- */
  function revealLazy() {
    each('.gps-lazy', document, function (el) {
      el.classList.remove('gps-lazy');
      el.style.removeProperty('content-visibility');
      el.style.removeProperty('contain-intrinsic-size');
    });
    each('.gps-hidden-lazy, [data-gps-lazy]', document, function (el) { el.classList.remove('gps-hidden-lazy'); el.removeAttribute('data-gps-lazy'); });
    // <img class="gp_lazyload" src="<inline svg spinner>" data-src="<real image>">:
    // the embed swaps data-src -> src on scroll; without it the 1:1 spinner
    // placeholder stays forever and blows sections up into giant blank squares.
    each('img.gp_lazyload, img[data-src]', document, function (im) {
      var ds = im.getAttribute('data-src');
      if (ds && im.getAttribute('src') !== ds) im.setAttribute('src', ds);
      var dss = im.getAttribute('data-srcset');
      if (dss) im.setAttribute('srcset', dss);
      im.classList.remove('gp_lazyload');
    });
    each('source[data-srcset]', document, function (s) { s.setAttribute('srcset', s.getAttribute('data-srcset')); });
  }

  /* ---- 3) Accordions (FAQ / product tabs) --------------------------------
     Baked structure per item: header div + body div (grid 0fr<->1fr pinned by
     baked CSS with !important). Force the body's box height inline+!important
     (nothing beats it) and drive our own transition. Initial open item comes
     from gp-data setting.activeKey (1-based) when expandItem is on. */
  function initAccordions() {
    each('gp-accordion', document, function (acc) {
      safe(function () {
        var active = -1, single = false;
        try {
          var cfg = JSON.parse(acc.getAttribute('gp-data') || '{}');
          var s = cfg.setting || {};
          if (s.expandItem && s.activeKey !== undefined && s.activeKey !== null && s.activeKey !== '') active = parseInt(s.activeKey, 10) - 1;
          single = s.expandedMode === 'single';
        } catch (e) {}
        var heads = acc.querySelectorAll('[class*="accordion-item_header"]');
        function setOpen(head, body, open, animate) {
          function setH(el, v) { el.style.setProperty('height', v, 'important'); }
          var inner = body.firstElementChild;
          if (inner) { inner.style.maxHeight = ''; inner.style.transition = ''; setH(inner, 'auto'); }
          body.style.overflow = 'hidden';
          body.style.transition = animate ? 'height .3s ease' : '';
          if (open) {
            if (animate) {
              setH(body, body.scrollHeight + 'px');
              body.addEventListener('transitionend', function te() { if (head.__tfOpen) setH(body, 'auto'); body.removeEventListener('transitionend', te); });
            } else {
              setH(body, 'auto');
            }
          } else {
            if (animate) { setH(body, body.scrollHeight + 'px'); void body.offsetHeight; }
            setH(body, '0px');
          }
          head.classList.toggle('active', open);
          head.setAttribute('aria-expanded', String(open));
          head.__tfOpen = open;
        }
        Array.prototype.forEach.call(heads, function (head, idx) {
          var body = head.nextElementSibling;
          if (!body || String(body.className).indexOf('accordion-item_body') === -1) return;
          if (!head.__tfBound) {
            head.__tfBound = true;
            head.style.cursor = 'pointer';
            head.addEventListener('click', function () {
              var opening = !head.__tfOpen;
              if (opening && single) {
                Array.prototype.forEach.call(heads, function (other) {
                  if (other !== head && other.__tfOpen) setOpen(other, other.nextElementSibling, false, true);
                });
              }
              setOpen(head, body, opening, true);
            });
          }
          if (head.__tfOpen === undefined) setOpen(head, body, idx === active, false);
        });
      });
    });
  }

  /* ---- 4) Products: add-to-cart via native AJAX + drawer ------------------ */
  var cartCache = {};
  function loadProduct(handle) {
    if (cartCache[handle]) return Promise.resolve(cartCache[handle]);
    return fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) { cartCache[handle] = p; return p; }).catch(function () { return null; });
  }
  function openDrawerAfterAdd() {
    var bubble = document.getElementById('cart-icon-bubble') || document.querySelector('.header__icon--cart');
    if (bubble) bubble.click();               // fp-cart.js intercepts this -> render + open drawer
  }
  var tfAbStamped = false;
  function stampAbAttribute() {
    // record which landing variant produced this cart — shows on the order in
    // Shopify admin ("Additional details: tf_ab"), the A/B conversion counter
    if (tfAbStamped) return;
    var v = abVariant();
    if (!v) return;
    tfAbStamped = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { tf_ab: v } })
    }).catch(function () { tfAbStamped = false; });
  }
  var tfAddBusy = false;
  function tfAddToCart(form) {
    if (tfAddBusy) return;                    // one in-flight add max (guards double triggers)
    tfAddBusy = true;
    var fd = new FormData(form);
    if (!fd.get('quantity')) fd.set('quantity', '1');
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/javascript' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        tfAddBusy = false;
        if (res && res.status) return;        // Shopify error payload
        abTrack('add_to_cart', { quantity: fd.get('quantity') });
        stampAbAttribute();
        openDrawerAfterAdd();
      })
      .catch(function () { tfAddBusy = false; });
  }

  function initProducts() {
    each('gp-product', document, function (prod) {
      safe(function () {
        if (prod.__tfBound) return;
        prod.__tfBound = true;
        var form = prod.querySelector('form[action*="/cart/add"], form[action$="/cart/add"], form[action*="cart"]');
        if (!form) return;
        var idInput = form.querySelector('input[name="id"]');

        // GemPages STICKY bars pick the variant with a <select> whose option
        // values ARE the variant ids (no radios). Keep the form id in sync.
        each('select', form, function (sel) {
          if (sel.__tfBound || !sel.options.length) return;
          var allVariantIds = Array.prototype.every.call(sel.options, function (o) { return /^\d{8,}$/.test(o.value); });
          if (!allVariantIds) return;
          sel.__tfBound = true;
          sel.addEventListener('change', function () {
            if (idInput) idInput.value = sel.value;
          });
        });

        // swallow any submit event and route through our single AJAX path
        form.addEventListener('submit', function (e) {
          e.preventDefault(); e.stopImmediatePropagation();
          tfAddToCart(form);
        }, true);
      });
    });
  }

  // Buy-button clicks: one document-level capture listener — document capture
  // fires before ANY element-level listener, so our cart flow always wins over
  // the real component handlers. Covers <gp-product-button> AND plain
  // <button type="submit">/<button name="add"> inside gp-product (sticky bar).
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var gpBtn = e.target.closest('gp-product-button');
    var subBtn = gpBtn ? null : e.target.closest('button[type="submit"], button[name="add"]');
    var host = gpBtn || subBtn;
    if (!host) return;
    var prod = host.closest('gp-product');
    if (!prod) return;
    if (e.target.closest('a[href]')) return;
    var form = (subBtn && subBtn.closest('form')) || prod.querySelector('form[action*="/cart/add"], form[action$="/cart/add"], form[action*="cart"]');
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    tfAddToCart(form);
  }, true);

  /* ---- 4b) Bundle tiers (1 / 2 / 3+1) --------------------------------------
     The baked gp-product-bundle-discount markup carries each tier's config as
     ATTRIBUTES (quantity / discounttype / discountvalue) but the component is
     INERT app-less (verified: clicks set no state, no quantity, and every tier
     shows the base unit price). Drive it ourselves:
       - price per tier, cents math matching Shopify rounding:
           no_discount        -> qty x unit
           percentage v       -> round(qty x unit x (100-v)/100)   (2x -15% = $100.22)
           label "+1 free"    -> pay qty x unit, cart quantity = qty+1 (BXGY: 4 units)
       - selection: swap the baked radio SVGs + selected background (#4D331B,
         read from the baked default item) and write the form quantity input.
     Charging is enforced server-side by the store's automatic discounts
     (Buy 2 = 15% OFF, Buy 3 + 1 FREE) — see the deployment checklist. */
  function initBundleTiers() {
    each('gp-product-bundle-discount', document, function (box) {
      safe(function () {
        if (box.__tfTiers) return;
        var items = box.querySelectorAll('gp-product-bundle-discount-item');
        if (!items.length) return;
        box.__tfTiers = true;
        var prod = box.closest('gp-product');
        var form = prod && prod.querySelector('form[action*="/cart/add"], form[action$="/cart/add"], form[action*="cart"]');
        var qtyInput = form && form.querySelector('input[name="quantity"]');
        if (form && !qtyInput) {
          qtyInput = document.createElement('input');
          qtyInput.type = 'hidden'; qtyInput.name = 'quantity';
          form.appendChild(qtyInput);
        }
        // unit price: parse the baked price text of the first tier ($58.95 -> 5895)
        function priceEl(it) {
          var els = it.querySelectorAll('.gp-price, .gp-money');
          for (var i = 0; i < els.length; i++) if (!els[i].children.length && /\$\s*\d/.test(els[i].textContent)) return els[i];
          return null;
        }
        var p0 = priceEl(items[0]);
        var unit = p0 ? Math.round(parseFloat(p0.textContent.replace(/[^0-9.]/g, '')) * 100) : 0;
        if (!unit) return;
        // capture the two baked radio states: the pre-selected item bakes the
        // FILLED icon, the rest bake the RING — clone their svg markup
        var svgFilled = null, svgRing = null, selBg = '';
        Array.prototype.forEach.call(items, function (it) {
          var svg = it.querySelector('.bundle-icon-section svg') || it.querySelector('svg');
          if (!svg) return;
          var filled = (svg.innerHTML.match(/Zm/g) || []).length >= 2; // filled radio = ring + inner dot subpaths
          if (filled && !svgFilled) { svgFilled = svg.innerHTML; selBg = getComputedStyle(it).backgroundColor; }
          if (!filled && !svgRing) svgRing = svg.innerHTML;
        });
        if (!selBg || selBg === 'rgba(0, 0, 0, 0)') selBg = 'rgb(77, 51, 27)';

        // price displays OUTSIDE the bundle: big price + compare (strike) +
        // "Sale $X off" badge — the baked markup never syncs them to the tier
        var mainPrice = null, comparePrice = null, saleBadge = null, compareUnit = 0;
        if (prod) {
          each('.gp-price.gp-money', prod, function (el) {
            if (mainPrice || el.closest('gp-product-bundle-discount')) return;
            if (el.classList.contains('gp-product-compare-price')) return;
            mainPrice = el;
          });
          comparePrice = prod.querySelector('.gp-product-compare-price');
          if (comparePrice && comparePrice.closest('gp-product-bundle-discount')) comparePrice = null;
          compareUnit = comparePrice ? Math.round(parseFloat(comparePrice.textContent.replace(/[^0-9.]/g, '')) * 100) : 0;
          each('pre, p, span, div', prod, function (n) {
            if (saleBadge || n.children.length) return;
            if (n.closest('gp-product-bundle-discount')) return;
            if (/sale\s*\$\s*[\d.,]+\s*off/i.test(n.textContent)) saleBadge = n;
          });
        }
        function fmtMoney(cents) {
          var v = cents / 100;
          return v % 1 === 0 ? '$' + v.toFixed(0) : '$' + v.toFixed(2);
        }

        var tiers = Array.prototype.map.call(items, function (it) {
          var qty = parseInt(it.getAttribute('quantity') || '1', 10) || 1;
          var type = it.getAttribute('discounttype') || 'no_discount';
          var val = parseFloat(it.getAttribute('discountvalue') || '0') || 0;
          var freeOne = /\+\s*1\s*free/i.test(it.textContent);
          var pay;
          if (type === 'percentage' && val > 0) pay = Math.round(qty * unit * (100 - val) / 100);
          else pay = qty * unit;
          return { el: it, qty: qty, cartQty: freeOne ? qty + 1 : qty, pay: pay };
        });

        function select(t) {
          tiers.forEach(function (o) {
            var on = o === t;
            // inline + !important: the baked default item carries the selected
            // brown as a CLASS, so clearing inline styles never un-highlights it
            o.el.style.setProperty('background-color', on ? selBg : 'transparent', 'important');
            var svg = o.el.querySelector('.bundle-icon-section svg') || o.el.querySelector('svg');
            if (svg && svgFilled && svgRing) svg.innerHTML = on ? svgFilled : svgRing;
          });
          if (qtyInput) qtyInput.value = String(t.cartQty);
          // sync the standalone price display with the selected tier
          if (mainPrice) mainPrice.textContent = money(t.pay);
          if (comparePrice && compareUnit) comparePrice.textContent = money(t.cartQty * compareUnit);
          if (saleBadge && compareUnit) {
            saleBadge.textContent = saleBadge.textContent.replace(/\$\s*[\d.,]+/, fmtMoney(t.cartQty * compareUnit - t.pay));
          }
        }

        tiers.forEach(function (t, i) {
          var pe = priceEl(t.el);
          if (pe) pe.textContent = money(t.pay);
          t.el.addEventListener('click', function (e) {
            if (e.target.closest('a[href]')) return;
            select(t);
          });
        });
        select(tiers[0]);
      });
    });
  }

  /* ---- 4a) Sticky-bar hit-area fix ----------------------------------------
     The sticky bar bakes full-bar "pointer-events-auto" overlays and image
     wrappers with negative margins that swallow real taps before they reach
     the buy button (programmatic .click() bypasses hit-testing — desktop tests
     pass while phones do nothing). Any such layer with no interactive element
     inside is safe to make click-transparent. */
  function fixStickyHitAreas() {
    each('gp-sticky [class*="pointer-events-auto"], gp-sticky [class*="gp-group/image"], gp-sticky gp-image, gp-sticky img', document, function (el) {
      if (el.querySelector && el.querySelector('button, a, select, input, textarea, label')) return;
      if (el.closest('button, a, select, label')) return;
      el.style.setProperty('pointer-events', 'none', 'important');
    });
  }

  // Safety net: taps inside gp-sticky landing on a NON-interactive element
  // whose coordinates fall within the buy button's (or select's) box act as
  // if the control itself was tapped.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var st = e.target.closest('gp-sticky');
    if (!st) return;
    if (e.target.closest('button, a, select, input, label')) return;
    var x = e.clientX, y = e.clientY;
    function hit(el) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return r.width > 0 && x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
    }
    var btn = st.querySelector('gp-product-button, button[type="submit"], button[name="add"]');
    if (hit(btn)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var prod = btn.closest('gp-product');
      var form = btn.closest('form') || (prod && prod.querySelector('form[action*="/cart/add"], form[action$="/cart/add"], form[action*="cart"]'));
      if (form) tfAddToCart(form);
      return;
    }
    var sel = st.querySelector('select');
    if (hit(sel)) {
      try { sel.focus(); if (sel.showPicker) sel.showPicker(); } catch (err) {}
    }
  }, true);

  /* ---- 5) init ------------------------------------------------------------ */
  ready(function () {
    // the embed adds "gpsi" to every .gps wrapper; the global var-mapping rules
    // (".gps.gpsi [style*=--x:]") only match with it — without gpsi, grid
    // columns/gaps silently collapse on every section that doesn't bake its own.
    safe(function () { each('.gps', document, function (el) { el.classList.add('gpsi'); }); });
    safe(revealLazy);
    safe(initAccordions);
    safe(initProducts);
    safe(initBundleTiers);
    safe(fixStickyHitAreas);
    safe(function () { abTrack('page_view', { page: location.pathname }); });
    // late passes: markup parsed late + real components that hydrate after us
    setTimeout(function () { safe(revealLazy); safe(initAccordions); safe(initProducts); safe(initBundleTiers); safe(fixStickyHitAreas); }, 800);
    setTimeout(function () { safe(fixStickyHitAreas); }, 2500);
  });
})();
